var _excluded = ["children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import c from 'classnames';
import CoreLink from '../CoreLink';
export var MenuItemWrapperDefault = function MenuItemWrapperDefault(_ref) {
  var level = _ref.level,
    className = _ref.className,
    children = _ref.children,
    buildMenu = _ref.buildMenu;
  return /*#__PURE__*/React.createElement("ul", {
    className: c("RecursiveMenu__layer__".concat(level), className)
  }, children.map(function (item) {
    return buildMenu(item);
  }));
};

// The default Menu Item component.
// You can overwrite this through the MenuItemLink prop.
export var MenuItemLinkDefault = function MenuItemLinkDefault(_ref2) {
  var children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement("li", props, children);
};
var MenuItemLinkElementDefault = function MenuItemLinkElementDefault(_ref3) {
  var item = _ref3.item,
    url = _ref3.url,
    title = _ref3.title,
    description = _ref3.description,
    alterUrlFunction = _ref3.alterUrlFunction,
    onClickFunction = _ref3.onClickFunction,
    minLevel = _ref3.minLevel,
    maxLevel = _ref3.maxLevel,
    buildMenu = _ref3.buildMenu,
    MenuItemWrapper = _ref3.MenuItemWrapper,
    linkProps = _ref3.linkProps;
  return /*#__PURE__*/React.createElement(React.Fragment, null, url ? /*#__PURE__*/React.createElement(CoreLink, _extends({}, linkProps, {
    title: title,
    className: "RecursiveMenu__title haslink",
    href: alterUrlFunction(url),
    onClick: function onClick() {
      return onClickFunction(false);
    }
  }), /*#__PURE__*/React.createElement("span", null, title)) : /*#__PURE__*/React.createElement("span", {
    className: "RecursiveMenu__title nolink"
  }, title), description && /*#__PURE__*/React.createElement("div", {
    className: "RecursiveMenu__description"
  }, description), item.has_children && !(item.depth >= maxLevel) && /*#__PURE__*/React.createElement(MenuItemWrapper, {
    level: item.depth - (minLevel ? minLevel - 1 : 0),
    buildMenu: buildMenu
  }, item.subtree));
};
export default MenuItemLinkElementDefault;